import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { VersionUpdateModalComponent } from '../components/version-update-modal/version-update-modal.component';

@Injectable({ providedIn: 'root' })
export class VersionUpdateService {

    private bsModalRef: BsModalRef | null = null;
    private CHECK_INTERVAL = 30 * 60 * 1000; // 30 minutes

    constructor(private updates: SwUpdate, private bsModalService: BsModalService) {
        // Check on app startup
        this.checkForUpdate();

        this.registerEvents();
        this.startCheckInterval();
    }

    public reloadPageAndRefreshCache(): void {
        this.clearServiceWorkerCache();
        window.location.href = window.location.origin + '?nocache=' + new Date().getTime();
    }

    private clearServiceWorkerCache(): void {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            registrations.forEach(reg => reg.update());
        });
    }

    private startCheckInterval(): void {
        // check periodically for updates
        setInterval(() => this.checkForUpdate(), this.CHECK_INTERVAL);
    }

    private registerEvents(): void {
        this.updates.versionUpdates.subscribe((event) => {
            if (event.type === 'VERSION_READY') {
                console.info('New version detected, forcing hard refresh...');
                this.showVersionUpdateModal();
            }
        });

        // check when app gains focus
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                this.checkForUpdate();
            }
        });
    }

    private showVersionUpdateModal(): void {
        this.bsModalRef = this.bsModalService.show(
            VersionUpdateModalComponent, {
            ignoreBackdropClick: true
        })
    }

    private checkForUpdate(): void {
        if (!this.isServiceWorkerActive()) return;
        this.updates.checkForUpdate();
    }

    private isServiceWorkerActive(): boolean {
        if (!('serviceWorker' in navigator)) return false;
        return this.updates.isEnabled;
    }
}